import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **The Percentage APP**
 *
 * @exports bs_395
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    // if the room name matches this regex it means the occupancy is 2 adults if not 1 adult
    const guestRegex = /private|privée|privato|privaat|prive|privado|matrimoniale|dopia|twin|quarto|tweepersoonskamer|prywatny|프라이빗|プライベート|プライベート|プライベート/i;
    let priceUpdate;
    /**
       * @memberOf module:bs_395
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        return false;
    };
    /**
     * @memberOf module:bs_0
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const url = new URL(ctx.baseUrl);
        const validUrl = url.pathname.includes('book-now');
        // https://astorhostels.com/book-now/?q_name=search_rooms&hostel_code=astor_hyde_park&chk_in=2023-12-26&chk_out=2023-12-28&guests=0&promocode_main=
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        ctx.newUrl = url.toString();
        return ctx;
    };
    /**
     * @memberOf module:bs_395
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
    engine.onStateChange = function onStateChange(ctx) {
        setTimeout(thn.pageCheck, 400);
    };
    /**
    * @memberOf module:bs_395
    * @see {@link prestart}
    *
    * @param {object} ctx - The context object.
    */
    engine.boot = function boot() {
        const container = document.documentElement;
        if (container) {
            const refreshLang = thn.debounce(thn.languageCheck, 500);
            thn.observeDom(container, refreshLang, {
                attributes: true,
                attributeFilter: ['lang'],
            });
            thn.shutdown(() => {
                refreshLang.cancel();
                thn.stopObserveDom(container, refreshLang);
            });
        }
    };
    /**
     * @memberOf module:bs_395
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('#pctShadowRoot')?.shadowRoot?.querySelector('.content-page');
        if (container && !priceUpdate) {
            priceUpdate = thn.debounce(() => {
                const loader = document.querySelector('#pctShadowRoot')?.shadowRoot?.querySelector('.pct-detail-lists-loading');
                if (!thn.isVisible(loader)) {
                    thn.widgets.price.refresh();
                }
            }, 500);
        }
        thn.observeDom(container, priceUpdate, {
            childList: true,
            subTree: true,
            attributes: true,
            characterData: true,
        });
        thn.pageUnload(() => {
            priceUpdate.cancel();
            thn.stopObserveDom(container, priceUpdate);
            priceUpdate = null;
        });
    };
    /**
    * @memberOf module:bs_395
    * @this thn.widgets.price
    * @see {@link Price#set_data}
    *
    * @param {object} ctx - The context object.
    */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Dates
        let nights;
        const dateBegin = thn.parseUrlParameter('chk_in')?.replace(/-/g, '/');
        const dateEnd = thn.parseUrlParameter('chk_out')?.replace(/-/g, '/');
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(dateBegin, dateEnd);
        }
        const roomsEl = document.querySelector('#pctShadowRoot')?.shadowRoot?.querySelectorAll('.pct-item-list');
        const roomInfo = [...roomsEl]?.map((room) => {
            const occupancy = room.querySelector('.pct-item-list-title')?.textContent?.match(guestRegex) ? 2 : 1;
            const pricesEl = room.querySelectorAll('.custom-offer-price');
            const prices = [...pricesEl].map((priceEl) => thn.parseNumber(priceEl?.textContent));
            const minPrice = Math.min(...prices);
            const currency = thn.parseCurrency(pricesEl[0].textContent);
            return {
                adults: occupancy || 2,
                children: 0, // the max occupancy does not distinguishes between adults and children
                price: minPrice,
                currency: currency,
            };
        }).filter(Boolean).sort((a, b) => a.price - b.price);
        // No availability
        const noAvailability = !!document.querySelector('#pctShadowRoot')?.shadowRoot?.querySelector('.booking-error') || document.querySelector('#pctShadowRoot')?.shadowRoot?.querySelector('#pct_search_rooms_rooms>div>div>.text-danger');
        if (!thn.empty(roomInfo) && nights) {
            // Guests, Adults & Children
            widgetData.adults = roomInfo[0].adults;
            widgetData.children = roomInfo[0].children;
            widgetData.guests = widgetData.adults + widgetData.children;
            // Price & currency
            widgetData.price = roomInfo[0].price / nights;
            widgetData.currency = roomInfo[0].currency;
            widgetData.roomDetails = engine._roomDetailsParseData(widgetData.adults, nights);
            widgetData.set = true;
        }
        else if (noAvailability) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
      *
      * @memberOf module:bs_395
      *
      */
    engine._roomDetailsParseData = function roomDetailsParseData(nights) {
        const roomsInfo = document.querySelector('#pctShadowRoot')?.shadowRoot?.querySelectorAll('.pct-item-list');
        const roomDetailsArray = [];
        roomsInfo?.forEach((room) => {
            const roomName = room.querySelector('.pct-item-list-title')?.textContent;
            const roomAdults = roomName?.match(guestRegex) ? 2 : 1;
            const roomChildren = 0;
            const roomType = getRoomType(roomName);
            const roomData = {
                id: '',
                name: roomName,
                adults: roomAdults,
                children: roomChildren,
                type: roomType,
                prices: [],
            };
            const ratesInfo = room.querySelectorAll('.pct-offer-price-list-item');
            ratesInfo?.forEach((rate) => {
                const rateName = rate.querySelector('.pct-offer-price-name')?.textContent;
                const price = thn.parseNumber(rate.querySelector('.custom-offer-price')?.textContent);
                let pricePerNight;
                if (price) {
                    pricePerNight = (Math.round((price / nights) * 100)) / 100;
                }
                const rateInfo = {
                    id: '',
                    name: rateName,
                    totalNight: pricePerNight,
                    breakfast: false,
                    refundable: !!rateName?.match(/flexible|弹性价格|유연한 요금|flessibile|フレキシブル料金|flastyczna|flexível/i),
                };
                roomData.prices.push(rateInfo);
            });
            roomDetailsArray.push(roomData);
        });
        return roomDetailsArray;
    };
    /**
    * @memberOf module:bs_395
    * @this thn.widgets.booking
    * @see {@link Booking#set_data}
    *
    * @param {object} ctx - The context object.
    */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        // bookingId
        const bookingId = document.querySelector('#pctShadowRoot')?.shadowRoot?.querySelector('.booking-refference span')?.textContent;
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        widgetData.bookingId = bookingId;
        // Dates - there is no way to obtain dates in BC step
        // Prices & currency
        const priceSel = document.querySelector('#pctShadowRoot')?.shadowRoot?.querySelector('.total span:last-child');
        widgetData.price = thn.parseNumber(priceSel?.textContent);
        widgetData.currency = thn.parseCurrency(priceSel?.textContent);
        return widgetData;
    };
    return engine;
}

export { factory };
